import { useEffect, useState } from "react";
import { useProviderContext } from "src/ether-utils/context/providerContext";
import StakedIncentivesABI from "src/assets/abis/StakedIncentivesABI.json";
import { ethers } from "ethers";
import { BscRTravaConfig, EthRTravaConfig, FtmRTravaConfig } from "src/config/balance/travaBalanceConfig";
import { convertBigNumber } from "src/ether-utils/utils";

export default function useRTravaBalance(accountAddress) {
  const [rTravaBalance, setRTravaBalance] = useState({});

  const { bscProvider, ftmProvider, ethProvider } = useProviderContext();

  const _fetchRTravaBalance = async (accountAddress, incentiveAddress, tokenList, _provider) => {
    const stakedIncentivesContract = new ethers.Contract(incentiveAddress, StakedIncentivesABI, _provider);
    const rewardRaw = await stakedIncentivesContract.getRewardsBalance(tokenList, accountAddress);
    return convertBigNumber(rewardRaw, 18, 2);
  };

  const _fetchAllRTravaBalance = async (accountAddress) => {
    const { incentiveAddress: bscAddress, tokenList: bscToken } = BscRTravaConfig;
    const { incentiveAddress: ftmAddress, tokenList: ftmToken } = FtmRTravaConfig;
    const { incentiveAddress: ethAddress, tokenList: ethToken } = EthRTravaConfig;
    let [bscRTrava, ftmRTrava, ethRTrava] = await Promise.all([
      _fetchRTravaBalance(accountAddress, bscAddress, bscToken, bscProvider),
      _fetchRTravaBalance(accountAddress, ftmAddress, ftmToken, ftmProvider),
      _fetchRTravaBalance(accountAddress, ethAddress, ethToken, ethProvider),
    ]);
    return { bscRTrava, ftmRTrava, ethRTrava };
  };

  useEffect(() => {
    if (bscProvider && ftmProvider && ethProvider) {
      _fetchAllRTravaBalance(accountAddress)
        .then((data) => {
          setRTravaBalance(data);
        })
        .catch((error) => {
          console.error("r trava balance error: ", error);
        });
    }
  }, [bscProvider, ftmProvider, ethProvider, accountAddress]);

  return rTravaBalance;
}
